import { Box, styled } from '@mui/material';

type GradientBackgroundType = {
  primaryColor: string;
  secondaryColor: string;
};
export const GradientBackground = styled(Box)<GradientBackgroundType>(({ theme, primaryColor, secondaryColor }) => ({
  background: `linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), linear-gradient(96deg, ${primaryColor} 0.7%, ${secondaryColor} 100%)`,
  height: '100%',
  color: theme.palette.common.white,
}));
